<template>
    <span class="float-right">
        <b-button @click="openModal" class="m-1" variant="outline-secondary" size="sm" v-b-tooltip.hover
            title="Verificar o que falta para finalizar esta licitação">
            <font-awesome-icon icon="clipboard-check" class="mr-1" />
            Verificar
        </b-button>
        <b-modal v-model="modalVisible" title="Verificar Licitação" centered header-bg-variant="secondary"
            header-text-variant="light" hide-footer>
            <div v-if="busy" class="d-flex justify-content-center m-3">
                <b-spinner class="m-1 text-center" />
            </div>
            <b-card-text v-else>
                <b-list-group v-if="erros.length" flush>
                    <b-list-group-item v-for="er in erros" :key="er">{{ er }}</b-list-group-item>
                </b-list-group>
                <span v-else>
                    <font-awesome-icon icon="clipboard-check" class="mr-1 text-success" />
                    <span class="font-weight-bold">Não há pendências para esta licitação.</span>
                </span>
            </b-card-text>
        </b-modal>
    </span>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'
import ldiService from '@/services/licitacoes/ldiService'

const CompProps = Vue.extend({
    name: 'ModalVerificarLicitacao',
    components: {},
    props: {
        idLicitacao: {
            type: Number,
            required: true
        }
    }
})

@Component
export default class ModalVerificarLicitacao extends mixins(UtilsTS, CompProps) {
    modalVisible = false
    busy = false
    erros: string[] = []

    async openModal(): Promise<void> {
        this.modalVisible = true;
        try {
            this.busy = true
            this.erros = []
            const response = await ldiService.listarPendenciasLicitacao(this.idLicitacao)
            if (response && response.length > 0) this.erros = response
        } catch (e: any) {
            this.tratarError(e)
        } finally {
            this.busy = false
        }
    }
}
</script>
